<template>
<div :class="bem()">
    <div :class="bem('form')" :style="`padding:0px ${vm.width < 400? 40: 80}px`">
        <SwitchLoginTab :type="type" />
        <div :class="bem('item')">
            <PhoneNumber
                v-model="vm.form.phone"
                :countries="vm.countries"
                name="username" />
        </div>
        <!-- 账号密码登录 -->
        <div :class="bem('item')" v-if="isPwdLogin">
            <GInput
                type="password"
                id="password"
                v-model="vm.form.password"
                name="password"
                placeholder="输入6-30位密码"
                maxlength="30"/>
        </div>
        <!-- 短信登录 -->
        <div :class="bem('item')" v-else>
            <!-- 禁止密码填充到验证码框中, 所以增加了一个隐藏的密码窗 -->
            <GInput type="password" :style="{ display: 'none' }" />
            <GInput
                v-model="vm.form.verifyCode"
                maxlength="4"
                autocomplete="off"
                placeholder="输入验证码" />
            <verifyCode
                :sendVerifyCode="sendVerifyCode"
                type="login"/>
        </div>
        <div :class="bem('links')">
            <Button
                nativeType="button"
                type="text"
                :class="bem('sms-login')"
                @click="vm.switchType('smsLogin')"
                v-if="isPwdLogin"
            >短信验证码登录</Button>
            <Button
                nativeType="button"
                type="text"
                :class="bem('sms-login')"
                @click="vm.switchType('phone')"
                v-else
            >密码登录</Button>
            <Button
                nativeType="button"
                type="text"
                :class="bem('resetwod')"
                @click="vm.switchType('resetpwd')"
            >忘记密码</Button>
        </div>

        <Button
            rect
            type="primary"
            size="large"
            nativeType="submit"
            :class="bem('submit')"
            :disabled="this.loading"
            @click="onLogin"
        >{{this.loading ? '登录中…' : '登录'}}</Button>
    </div>
    <!-- 其它方式登录 -->
    <OtherWayLogin type='wechat' />
    <CapchaDialog ref="refCapchaDialog" type="login" :isUnSendCode="true" @onOk="capchaSendOk" />
</div>

</template>
<script>
import _Input from "@gaoding/gdui/lib/input";
import _Button from "@gaoding/gdui/lib/button";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import PhoneNumber from './phone-number/index.vue';
import verifyCode from './verify-code.vue';
import SwitchLoginTab from './components/SwitchLoginTab.vue';
import bemMixin from './bem';
import { getConfig } from './config';
import OtherWayLogin from './OtherWayLogin.vue';
import CapchaDialog from './capchaDialog/index.vue';
import { UMS_CAPCHA_CODE } from './constants';
export default {
  name: 'g-auth-login',
  components: {
    Button: _Button,
    PhoneNumber: PhoneNumber,
    GInput: _Input,
    verifyCode: verifyCode,
    OtherWayLogin: OtherWayLogin,
    CapchaDialog: CapchaDialog,
    SwitchLoginTab: SwitchLoginTab
  },
  mixins: [bemMixin],
  inject: ['vm'],
  props: {
    type: {
      type: String,
      default: 'pwd' // pwd: 账号密码登录  sms: 短信登录

    }
  },
  data: function data() {
    return {
      REQUEST_URL: getConfig('gaodingURL'),
      loading: false
    };
  },
  computed: {
    isPwdLogin: function isPwdLogin() {
      // 是否密码登录类型, 否则为 短信登录类型
      return this.type === 'pwd';
    }
  },
  methods: {
    sendVerifyCode: function sendVerifyCode() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.vm.requestUms('sendVerifyCode', _objectSpread(_objectSpread({}, _this.vm.form), {}, {
                  type: 'login'
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onLogin: function onLogin() {
      var _this2 = this;

      if (this.loading) return;
      this.loading = true;
      var p = this.isPwdLogin ? this.pwdLogin() : this.smsLogin();
      p.finally(function () {
        _this2.loading = false;
      });
    },
    pwdLogin: function pwdLogin(from) {
      var _this3 = this;

      var requestData = _objectSpread({}, this.vm.form);

      if (from && from.captcha) {
        requestData.captcha = from.captcha;
      }

      return this.vm.requestUms('login', requestData).then(function (res) {
        return _this3.vm.onLogin('mobile');
      }).catch(function (error) {
        if (UMS_CAPCHA_CODE.includes(error.error_code)) {
          _this3.$refs.refCapchaDialog.show();
        }

        _this3.vm.$emit('error', {
          error: error,
          action: 'login',
          type: 'mobile'
        });
      });
    },
    smsLogin: function smsLogin() {
      var _this4 = this;

      return this.vm.requestUms('verifyCodeLogin', this.vm.form).then(function (res) {
        return _this4.vm.onLogin('verify-code');
      }).catch(function (error) {
        _this4.vm.$emit('error', {
          error: error,
          action: 'register',
          type: 'mobile'
        });
      });
    },
    capchaSendOk: function capchaSendOk(captcha) {
      this.pwdLogin({
        captcha: captcha
      });
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-login {
  height: 100%;
}
.g-auth-login input::placeholder {
  font-size: 12px;
}
.g-auth-login .g-input {
  color: #000;
}
.g-auth-login .g-auth-login__title {
  line-height: 20px;
  font-size: 20px;
  font-weight: 500;
  height: 20px;
  margin-bottom: 26px;
  text-align: center;
  font-family: PingFang SC;
  color: #000;
}
.g-auth-login .g-auth-login__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.g-auth-login .g-auth-login__qq {
  display: flex;
  align-items: center;
}
.g-auth-login .g-auth-login__qq .g-icon {
  font-size: 44px;
}
.g-auth-login .g-auth-login__item {
  display: flex;
}
.g-auth-login .g-auth-login__item label {
  width: 42px;
}
.g-auth-login__item + .g-auth-login__item {
  margin-top: 8px;
}
.g-auth-login .g-auth-login__submit {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 16px;
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
}
.g-auth-login .g-auth-login__links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  line-height: 20px;
  font-weight: 400;
  color: #444950;
}
.g-auth-login .g-auth-login__links .g-btn {
  font-size: 12px;
}
.g-auth-login .g-auth-login__icon-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: #8d949e;
  cursor: pointer;
}
.g-auth-login__icon-wrap + .g-auth-login__icon-wrap {
  margin-left: 80px;
}
.g-auth-login .g-auth-login__sms-login {
  color: #2254F4;
}
.g-auth-login .g-auth-login__resetwod {
  color: #444950;
}
.g-auth-login .g-auth-login__icon-bg {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f8fafc;
  margin-bottom: 8px;
}
.g-auth-login .g-auth-login__icon-bg:hover {
  background: #f0f3f4;
}
.g-auth-login .g-auth-login__icon-wechat,
.g-auth-login .g-auth-login__icon-qq {
  width: 100%;
  height: 100%;
}
.g-auth-login .g-auth-login__third-parties {
  margin-top: 38px;
  width: 100%;
}
.g-auth-login .g-auth-login__third-parties-content {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.g-auth-login .g-auth-login__third-parties-title {
  display: flex;
  align-items: center;
}
.g-auth-login .g-auth-login__third-parties-text {
  font-size: 12px;
  line-height: 17px;
  color: #8D949E;
  padding: 0 16px;
}
.g-auth-login .g-auth-login__third-parties-line {
  flex: 1;
  height: 1px;
  background: #dadde1;
}
.g-auth-login .g-btn--text {
  line-height: 1;
}
.g-auth-login .g-auth-login__footer {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: 0;
  left: 0;
  height: 36px;
  width: 100%;
  padding: 0 20px;
  background: linear-gradient(216deg, #f9fafb 0%, #f8fafb 57%, #f0f2f6 100%);
  font-size: 12px;
  color: #8d949e;
}
.g-auth-login .g-auth-login__footer .g-btn {
  color: #2254f4;
  padding: 0;
  background: transparent;
}
.g-auth-login .g-auth-login__footer .g-btn:hover {
  font-weight: bolder;
}
.g-auth-login .g-auth-login__footer > span {
  font-size: 14px;
  color: #8d949e;
}
.g-auth-login .g-auth-login__footer a {
  color: #444950;
}
.g-auth-login .g-auth-login__footer .g-icon {
  font-size: 20px;
}
.g-auth-login__register-btn {
  font-size: 12px;
}

</style>
